import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Baza } from '@core/interfaces/models/baza.interface';
import { MbiemriGjinia, MbiemriLloji, MbiemriLlojiTemaShumesit } from '@core/enums/mbiemri.enums';
import { MbiemriAsnjanesForCreationDTO } from '@core/interfaces/dto/mbiemri-asnjanes-for-creation-dto.interface';
import { MbiemriBazaForCreationDTO } from '@core/interfaces/dto/mbiemri-baza-for-creation-dto.interface';
import { MbiemriBazaForUpdateDTO } from '@core/interfaces/dto/mbiemri-baza-for-update-dto.interface';
import { MbiemriFemerorForCreationDTO } from '@core/interfaces/dto/mbiemri-femeror-for-creation-dto.interface';
import { MbiemriMashkullorForCreationDTO } from '@core/interfaces/dto/mbiemri-mashkullor-for-creation-dto.interface';
import { MbiemriAsnjanesEmerMbiemerService } from './mbiemri-asnjanes-emer-mbiemer.service';
import { MbiemriAsnjanesMbiemerEmerService } from './mbiemri-asnjanes-mbiemer-emer.service';
import { MbiemriAsnjanesService } from './mbiemri-asnjanes.service';
import { MbiemriFemerorEmerMbiemerService } from './mbiemri-femeror-emer-mbiemer.service';
import { MbiemriFemerorMbiemerEmerService } from './mbiemri-femeror-mbiemer-emer.service';
import { MbiemriFemerorService } from './mbiemri-femeror.service';
import { MbiemriMashkullorEmerMbiemerService } from './mbiemri-mashkullor-emer-mbiemer.service';
import { MbiemriMashkullorMbiemerEmerService } from './mbiemri-mashkullor-mbiemer-emer.service';
import { MbiemriMashkullorService } from './mbiemri-mashkullor.service';
import { Subject } from 'rxjs';
import { MbiemriBaza } from '@core/interfaces/models/mbiemri-baza.interface';

@Injectable({
  providedIn: 'root',
})
export class MbiemriEditorService {
  constructor(
    private mbiemriMashkullorService: MbiemriMashkullorService,
    private mbiemriFemerorService: MbiemriFemerorService,
    private mbiemriAsnjanesService: MbiemriAsnjanesService,
    private mbiemriMashkullorEmerMbiemerService: MbiemriMashkullorEmerMbiemerService,
    private mbiemriMashkullorMbiemerEmerService: MbiemriMashkullorMbiemerEmerService,
    private mbiemriFemerorEmerMbiemerService: MbiemriFemerorEmerMbiemerService,
    private mbiemriFemerorMbiemerEmerService: MbiemriFemerorMbiemerEmerService,
    private mbiemriAsnjanesEmerMbiemerService: MbiemriAsnjanesEmerMbiemerService,
    private mbiemriAsnjanesMbiemerEmerService: MbiemriAsnjanesMbiemerEmerService,
    private fb: UntypedFormBuilder
  ) { }

  getMbiemriBazaForm(form: UntypedFormGroup) {
    if (form.get('mbiemriBaza')) {
      return form.get('mbiemriBaza') as UntypedFormGroup;
    }

    form.addControl(
      'mbiemriBaza',
      this.fb.group({
        id: null,
        bazaId: null,
        shkallaId: null,
        gjiniaId: null,
        llojiId: null,
        temaShumesitId: null,
        // mbiemriAsnjanes: this.fb.array([]),
        // mbiemriAsnjanesInitial: this.fb.array([]),
        // mbiemriAsnjanesFormula: this.fb.array([]),
        mbiemriAsnjanesEmerMbiemer: this.fb.array([]),
        mbiemriAsnjanesEmerMbiemerInitial: this.fb.array([]),
        mbiemriAsnjanesMbiemerEmer: this.fb.array([]),
        mbiemriAsnjanesMbiemerEmerInitial: this.fb.array([]),
        mbiemriMashkullorEmerMbiemer: this.fb.array([]),
        mbiemriMashkullorEmerMbiemerInitial: this.fb.array([]),
        mbiemriMashkullorMbiemerEmer: this.fb.array([]),
        mbiemriMashkullorMbiemerEmerInitial: this.fb.array([]),
        // mbiemriMashkullorInitial: this.fb.array([]),
        // mbiemriFemeror: this.fb.array([]),
        // mbiemriFemerorInitial: this.fb.array([]),
        // mbiemriFemerorFormula: this.fb.array([]),
        mbiemriFemerorEmerMbiemer: this.fb.array([]),
        mbiemriFemerorEmerMbiemerInitial: this.fb.array([]),
        mbiemriFemerorMbiemerEmer: this.fb.array([]),
        mbiemriFemerorMbiemerEmerInitial: this.fb.array([]),
        m1: null,
        m1a: null,
        m1b: null,
        m2: null,
        m2a: null,
        m2b: null,
        m3: null,
        m4: null
      })
    );

    form.addControl(
      'grupimiMbiemriBaza',
      this.fb.group({
        id: null,
        bazaId: null,
        nyjaId: null,
        fjala: '',
        homonimi: null,
        shkallaId: null,
        gjiniaId: null,
        llojiId: null,
        temaShumesitId: null
      })
    )

    this.mbiemriMashkullorEmerMbiemerService.generateForms(form.get('mbiemriBaza.mbiemriMashkullorEmerMbiemer') as UntypedFormArray);
    this.mbiemriMashkullorEmerMbiemerService.generateForms(form.get('mbiemriBaza.mbiemriMashkullorEmerMbiemerInitial') as UntypedFormArray);
    this.mbiemriMashkullorMbiemerEmerService.generateForms(form.get('mbiemriBaza.mbiemriMashkullorMbiemerEmer') as UntypedFormArray);
    this.mbiemriMashkullorMbiemerEmerService.generateForms(form.get('mbiemriBaza.mbiemriMashkullorMbiemerEmerInitial') as UntypedFormArray);
    this.mbiemriFemerorEmerMbiemerService.generateForms(form.get('mbiemriBaza.mbiemriFemerorEmerMbiemer') as UntypedFormArray);
    this.mbiemriFemerorEmerMbiemerService.generateForms(form.get('mbiemriBaza.mbiemriFemerorEmerMbiemerInitial') as UntypedFormArray);
    this.mbiemriFemerorMbiemerEmerService.generateForms(form.get('mbiemriBaza.mbiemriFemerorMbiemerEmer') as UntypedFormArray);
    this.mbiemriFemerorMbiemerEmerService.generateForms(form.get('mbiemriBaza.mbiemriFemerorMbiemerEmerInitial') as UntypedFormArray);
    this.mbiemriAsnjanesEmerMbiemerService.generateForms(form.get('mbiemriBaza.mbiemriAsnjanesEmerMbiemer') as UntypedFormArray);
    this.mbiemriAsnjanesEmerMbiemerService.generateForms(form.get('mbiemriBaza.mbiemriAsnjanesEmerMbiemerInitial') as UntypedFormArray);
    this.mbiemriAsnjanesMbiemerEmerService.generateForms(form.get('mbiemriBaza.mbiemriAsnjanesMbiemerEmer') as UntypedFormArray);
    this.mbiemriAsnjanesMbiemerEmerService.generateForms(form.get('mbiemriBaza.mbiemriAsnjanesMbiemerEmerInitial') as UntypedFormArray);
    return form.get('mbiemriBaza') as UntypedFormGroup;
  }

  getGrupimiMbiemriBazaForm(form: UntypedFormGroup) {
    if (!form.get('grupimiMbiemriBaza')) {
      this.getMbiemriBazaForm(form);
    }

    return form.get('grupimiMbiemriBaza') as UntypedFormGroup;
  }

  generateMbiemriMashkullorFormula(baza: string, mbiemriBaza: MbiemriBaza, form: UntypedFormGroup) {
    this.mbiemriMashkullorEmerMbiemerService.generateFormula(baza, mbiemriBaza, form);
    this.mbiemriMashkullorMbiemerEmerService.generateFormula(baza, mbiemriBaza, form);
  }

  generateMbiemriFemerorFormula(baza: string, mbiemriBaza: MbiemriBaza, form: UntypedFormGroup) {
    this.mbiemriFemerorEmerMbiemerService.generateFormula(baza, mbiemriBaza, form);
    this.mbiemriFemerorMbiemerEmerService.generateFormula(baza, mbiemriBaza, form);
  }

  generateMbiemriAsnjanesFormula(baza: string, mbiemriBaza: MbiemriBaza, form: UntypedFormGroup) {
    this.mbiemriAsnjanesEmerMbiemerService.generateFormula(baza, mbiemriBaza, form);
    this.mbiemriAsnjanesMbiemerEmerService.generateFormula(baza, mbiemriBaza, form);
  }

  getMbiemriBazaDTO(form: UntypedFormGroup) {
    const mb = this.getMbiemriBazaForm(form).getRawValue();
    const mbiemriMashkullorForCreationDTO: MbiemriMashkullorForCreationDTO[] = this.mbiemriMashkullorService.getCreationDTO(mb);
    const mbiemriFemerorForCreationDTO: MbiemriFemerorForCreationDTO[] = this.mbiemriFemerorService.getCreationDTO(mb);
    const mbiemriAsnjanesForCreationDTO: MbiemriAsnjanesForCreationDTO[] = this.mbiemriAsnjanesService.getCreationDTO(mb);

    if (mb.id) {
      const mbiemriBazaForUpdateDTO: MbiemriBazaForUpdateDTO = {
        id: mb.id,
        bazaId: mb.bazaId,
        gjiniaId: mb.gjiniaId,
        llojiId: mb.llojiId,
        temaShumesitId: mb.temaShumesitId,
        mbiemriMashkullorForCreationDTO: mb.gjiniaId == MbiemriGjinia.Mashkullore ? mbiemriMashkullorForCreationDTO : undefined,
        mbiemriFemerorForCreationDTO: mb.gjiniaId == MbiemriGjinia.Femerore ? mbiemriFemerorForCreationDTO : undefined,
        mbiemriAsnjanesForCreationDTO: mb.gjiniaId == MbiemriGjinia.Asnjanese ? mbiemriAsnjanesForCreationDTO : undefined,
        m1: mb.m1,
        m1a: mb.m1a,
        m1b: mb.m1b,
        m2: mb.m2,
        m2a: mb.m2a,
        m2b: mb.m2b,
        m3: mb.m3,
        m4: mb.m4,
      };
      return mbiemriBazaForUpdateDTO;
    } else {
      const mbiemriBazaForCreationDTO: MbiemriBazaForCreationDTO = {
        id: mb.id,
        bazaId: mb.bazaId,
        gjiniaId: mb.gjiniaId,
        llojiId: mb.llojiId,
        temaShumesitId: mb.temaShumesitId,
        mbiemriMashkullorForCreationDTO: mb.gjiniaId == MbiemriGjinia.Mashkullore ? mbiemriMashkullorForCreationDTO : undefined,
        mbiemriFemerorForCreationDTO: mb.gjiniaId == MbiemriGjinia.Femerore ? mbiemriFemerorForCreationDTO : undefined,
        mbiemriAsnjanesForCreationDTO: mb.gjiniaId == MbiemriGjinia.Asnjanese ? mbiemriAsnjanesForCreationDTO : undefined,
        m1: mb.m1,
        m1a: mb.m1a,
        m1b: mb.m1b,
        m2: mb.m2,
        m2a: mb.m2a,
        m2b: mb.m2b,
        m3: mb.m3,
        m4: mb.m4,
      };

      return mbiemriBazaForCreationDTO;
    }
  }

  insertMbiemriBazaIntoEditor(baza: Baza, form: UntypedFormGroup) {
    this.resetMbiemriBaza(form);

    this.getMbiemriBazaForm(form).patchValue({
      id: baza.mbiemriBaza.id,
      bazaId: baza.mbiemriBaza.bazaId,
      shkallaId: baza.mbiemriBaza.shkallaId,
      gjiniaId: baza.mbiemriBaza.gjiniaId,
      llojiId: baza.mbiemriBaza.llojiId,
      temaShumesitId: baza.mbiemriBaza.temaShumesitId,
      m1: baza.mbiemriBaza.m1,
      m1a: baza.mbiemriBaza.m1a,
      m1b: baza.mbiemriBaza.m1b,
      m2: baza.mbiemriBaza.m2,
      m2a: baza.mbiemriBaza.m2a,
      m2b: baza.mbiemriBaza.m2b,
      m3: baza.mbiemriBaza.m3,
      m4: baza.mbiemriBaza.m4,
    });


    if (baza.grupimiMbiemriBaza) {
      this.getGrupimiMbiemriBazaForm(form).patchValue({
        id: baza.grupimiMbiemriBaza.id,
        bazaId: baza.grupimiMbiemriBaza.bazaId,
        nyjaId: baza.grupimiMbiemriBaza.nyjaId,
        fjala: baza.grupimiMbiemriBaza.fjala,
        homonimi: baza.grupimiMbiemriBaza.homonimi,
        shkallaId: baza.grupimiMbiemriBaza.shkallaId,
        gjiniaId: baza.grupimiMbiemriBaza.gjiniaId,
        llojiId: baza.grupimiMbiemriBaza.llojiId,
        temaShumesitId: baza.grupimiMbiemriBaza.temaShumesitId,
      });
    }

    this.mbiemriMashkullorEmerMbiemerService.insertForms(baza.mbiemriBaza, form);
    this.mbiemriMashkullorMbiemerEmerService.insertForms(baza.mbiemriBaza, form);
    this.mbiemriFemerorEmerMbiemerService.insertForms(baza.mbiemriBaza, form);
    this.mbiemriFemerorMbiemerEmerService.insertForms(baza.mbiemriBaza, form);
    this.mbiemriAsnjanesEmerMbiemerService.insertForms(baza.mbiemriBaza, form);
    this.mbiemriAsnjanesMbiemerEmerService.insertForms(baza.mbiemriBaza, form);
  }

  private resetMbiemriBaza(form: UntypedFormGroup) {
    this.getMbiemriBazaForm(form).reset({
      id: null,
      bazaId: null,
      shkallaId: null,
      gjiniaId: null,
      llojiId: null,
      temaShumesitId: null,
      m1: null,
      m1a: null,
      m1b: null,
      m2: null,
      m2a: null,
      m2b: null,
      m3: null,
      m4: null,
    });

    Object.keys(this.getMbiemriBazaForm(form).controls)
      .filter((c) => c.startsWith('mbiemri'))
      .flatMap((field) => {
        return form.get('mbiemriBaza')?.get(field) as UntypedFormArray;
      })
      .forEach((formArray) => {
        while (formArray.controls.length > 0) {
          formArray.removeAt(0);
        }
      });
  }

  private _onOpenChooseKompozitenDialog$: Subject<void> = new Subject<void>();

  triggerOpenChooseKompozitenDialog() {
    this._onOpenChooseKompozitenDialog$.next();
  }

  onChooseKompozitenDialogOpen() {
    return this._onOpenChooseKompozitenDialog$.asObservable();
  }
}
